export default __webpack_public_path__ + "static/media/aviso-MB.2bc1c9e9.pdf";